<template>
  <setting-account-form
    :id="Number($route.params.id)"
    @submit="update"
  />
</template>

<style>
.certification-number-length {
  width: 5em;
}
</style>

<script>
import SettingAccountForm from '@/components/organisms/SettingAccountForm'

export default {
  components: {
    SettingAccountForm
  },
  methods: {
    update (value) {
      this.$http.secured.put(`/account/edit/settings/staff/${this.$route.params.id}`, value).then(response => {
        this.$router.push({ name: 'settingAccounts' })
      })
    }
  }
}
</script>
